import {
  ClipboardTextIcon,
  EyedropperSampleIcon,
  Mtds,
  PackageIcon,
  TagIcon,
  ThermometerIcon,
  useGetPlanByIdQuery
} from 'prove-common'
import styles from './TaskInstructions.module.css'

const sections = [
  {
    key: 'samplingInstructions',
    title: 'Hvordan ta ut prøven',
    icon: EyedropperSampleIcon
  },
  {
    key: 'storageInstructions',
    title: 'Hvordan oppbevare prøven',
    icon: ThermometerIcon
  },
  {
    key: 'labelingInstructions',
    title: 'Hvordan merke prøven',
    icon: TagIcon
  },
  {
    key: 'shippingInstructions',
    title: 'Hvordan sende prøven',
    icon: PackageIcon
  },
  {
    key: 'followUpInstructions',
    title: 'Hvordan følge opp prøvesvaret',
    icon: ClipboardTextIcon
  }
] as const

export function TaskInstructions({ planId }: Readonly<{ planId: number }>) {
  const plan = useGetPlanByIdQuery(planId)
  const visibleSections = sections.filter(
    ({ key }) => (plan.data?.[key] ?? '').trim() !== ''
  )

  return (
    <Mtds.Grid as='section' data-gap='5' aria-label='Slik gjør du det'>
      <Mtds.Heading as='h2' data-size='sm'>
        Slik gjør du det
      </Mtds.Heading>
      {plan.isPending && <p role='status'>Laster instruksjoner…</p>}
      {!plan.isPending && !plan.isError && visibleSections.length === 0 && (
        <p>Ingen instruksjoner er lagt til.</p>
      )}
      {plan.isError && (
        <Mtds.Alert data-color='danger' role='alert'>
          <Mtds.Grid>
            <p>Kunne ikke laste instruksjonene.</p>
            <Mtds.Button
              type='button'
              data-variant='secondary'
              data-justify-self='start'
              onClick={() => void plan.refetch()}
            >
              Prøv igjen
            </Mtds.Button>
          </Mtds.Grid>
        </Mtds.Alert>
      )}
      {visibleSections.length > 0 && (
        <Mtds.Steps data-direction='down'>
          {visibleSections.map(({ key, title, icon: Icon }) => (
            <li key={key}>
              <mark>
                <Icon aria-hidden />
              </mark>
              <Mtds.Grid data-gap='3'>
                <Mtds.Heading as='h3' data-size='2xs'>
                  {title}
                </Mtds.Heading>
                <Mtds.Card data-pad='4'>
                  <p className={styles.instructionText}>{plan.data?.[key]}</p>
                </Mtds.Card>
              </Mtds.Grid>
            </li>
          ))}
        </Mtds.Steps>
      )}
    </Mtds.Grid>
  )
}
